<template>
  <v-container>
      <v-card class='mb-4 green lighten-5'>
        <v-card-title>
          Rental price
        </v-card-title>
        <v-card-subtitle>
          Total price including all taxes
        </v-card-subtitle>
        <v-card-text class='display-2 pb-1'>
          {{quotationData['prettyTotalPrice']}}
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-card-title>Final step</v-card-title>
        <v-card-text>
          <v-form ref='finalForm'>
            <v-select v-model="passengers" @change="$refs.finalForm.resetValidation()" :rules="[checkDriverPassenger,stdRules.required]"  label="Select number of passengers including drivers" :items="numberOfPassengers"></v-select>
            <v-select v-model="drivers" :rules="[checkDriverPassenger,stdRules.required]" label="Select number of drivers" :items="numberOfPassengers"></v-select>

            <v-row>
              <v-col cols="8">
                <v-text-field :rules="[stdRules.required]" v-model="finalData.address" label="Home address"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field :rules="[stdRules.required]" v-model="finalData.zip" label="Zipcode"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="8">
                <v-text-field :rules="[stdRules.required]" v-model="finalData.city" label="City"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field :rules="[stdRules.required]" v-model="finalData.country" label="Country"></v-text-field>
              </v-col>
            </v-row>
            <v-text-field :rules="[stdRules.required]" v-model="finalData.telephone" label="Telephone number"></v-text-field>
            <v-row>
              <v-col md="5">
                <v-row align="center">
                  <v-col>
                      <v-checkbox v-model="finalData.agree" :rules="[stdRules.required]" label="I have read and agreed with the general terms and conditions"></v-checkbox>
                  </v-col>
                  <v-col>
                      <a target="_new" href="https://jeepsrentalcuracao.com/TOCmrparadise.pdf">Download Terms and Conditions</a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <vue-recaptcha
              sitekey="6LeiQ40qAAAAAO2ACl42bfG01S2QE97H4RaVKlM1"
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              size="invisible"
              data-badge="inline"
            ></vue-recaptcha>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="btnCheckoutDisabled" @click="makeReservation()" class='ma-3 green white--text'>Rent car</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="showDialog" width="50%">
        <v-card>
          <v-card-title>You've just made a jeep reservation!</v-card-title>
          <v-card-text>We will confirm asap.</v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" fullscreen full-width>
        <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
      <v-dialog v-model="errorDialog" width="50%">
        <v-card>
          <v-card-title class='red lighten-1'>
            <v-icon
                large
                left
              >
                mdi-alert
              </v-icon>
            Error</v-card-title>
          <v-card-text>{{error}}<br />
Please try again Later, or whatsapp/call +5999-5158004 for assistance.
          </v-card-text>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>

import GlobalHelper from "../mixins/GlobalHelper"
import VueRecaptcha from 'vue-recaptcha'

  export default {
    name: 'Finalize',
    mixins: [GlobalHelper],
    components:{
      VueRecaptcha
    },
    data: () => ({
      passengers:"",
      drivers:"",
      finalData:[],
      showDialog:false,
      loading:false,
      btnCheckoutDisabled:false,
      error:"",
      errorDialog:false,
      reserved:false
    }),
    mounted(){
    },
    methods:{
      onVerify: function (recaptcha) {
        let data = {
          ...this.$store.state.userData,
          ...this.finalData,
          passengers:this.passengers,
          drivers:this.drivers,
          recaptcha:recaptcha
        }
        //console.log(data);return;
        this.sendToServer(data).then(()=>{
          this.loading = false
          this.showDialog = true
          this.reserved=true
        }).catch((e)=>{
          this.error = e
          this.errorDialog = true
        }).finally(()=>{
          this.loading=false
          this.btnCheckoutDisabled = false
        })
      },
      onExpired: function () {
        //this.$refs.invisibleRecaptcha.reset()
      },
      resetRecaptcha () {
        this.$refs.invisibleRecaptcha.reset() // Direct call reset method
      },
      makeReservation(){
        this.btnCheckoutDisabled = true
        this.loading = true
        if(!this.$refs.finalForm.validate()){
          this.loading = false
          this.btnCheckoutDisabled = false
          return
        }
        this.$refs.invisibleRecaptcha.reset()
        this.$refs.invisibleRecaptcha.execute()
      },
      checkDriverPassenger(){
        if(this.passengers < this.drivers){
          return "Cannot have more drivers than passengers"
        }
        return true
      },
      doit(){
        this.showDialog = 1
        console.log("doit")
      }
    },
    computed:{
      numberOfPassengers(){
        let res = []
        for(let i=1;i<5;i++){
          res.push(i)
        }
        return res
      }
    },
    watch:{
      showDialog(){
        if(this.reserved){
          document.location = "https://mister-paradise.com"
        }
      }
    }
  }
</script>
